var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 219.26 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-logo-1{fill:#1d1d3c;}.cls-logo-2{fill:#fff;}.cls-logo-3{fill:#a440f2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-logo-1",
    d: "M0,0V256H219.26V0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-logo-2",
    points: "109.8 72.98 109.8 146.19 182.7 146.19 182.7 182.86 36.56 182.86 36.56 36.57 182.7 36.57 182.7 72.98 109.8 72.98"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-logo-3",
    x: 36.56,
    y: 220.16,
    width: 146.14,
    height: 7.91
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.e89cfb802f61fae9a670401c9b3beef3.svg";
export { ForwardRef as ReactComponent };